// -- Tour Packages -------------------------------------------------------------

export const ALL_PACKAGES = `
  *[_type == "tourPackage" && is_published == true] {
    _id,
    _updatedAt,
    title,
    slug,
    destination,
    region,
    theme,
    duration_days,
    duration_nights,
    price_per_person_aed,
    is_featured,
    is_published,
    hotel_name,
    hotel_stars,
    hero_image,
    inclusions,
    description,
    highlights
  }
`;

export const ALL_UMRAH_PACKAGES = `
  *[_type == "umrahPackage" && is_published == true] | order(priceFromAED asc) {
    _id,
    title,
    slug,
    travelMode,
    badge,
    ramadanAvailable,
    durationNights,
    makkahNights,
    madinahNights,
    occupancy,
    hotelCategory,
    hotelExamples,
    priceFromAED,
    departureCity,
    departureDays,
    description,
    inclusions,
    exclusions,
    image
  }
`;

export const PACKAGE_BY_SLUG = `
  *[_type == "tourPackage" && slug.current == $slug][0] {
    _id,
    _updatedAt,
    title,
    slug,
    destination,
    region,
    theme,
    duration_days,
    duration_nights,
    price_per_person_aed,
    is_featured,
    is_published,
    hotel_name,
    hotel_stars,
    hero_image,
    gallery,
    description,
    inclusions,
    exclusions,
    highlights,
    itinerary,
    body,
    cancellationPolicy,
    cancellation_policy,
    faqs
  }
`;

export const PACKAGES_BY_DESTINATION = `
  *[_type == "tourPackage" && destination == $destination && is_published == true] {
    _id,
    title,
    slug,
    destination,
    region,
    duration_days,
    duration_nights,
    price_per_person_aed,
    is_featured,
    is_published,
    hero_image,
    inclusions
  }
`;

export const PACKAGES_BY_REGION = `
  *[_type == "tourPackage" && region == $region && is_published == true] {
    _id,
    title,
    slug,
    destination,
    region,
    theme,
    duration_days,
    duration_nights,
    price_per_person_aed,
    is_featured,
    is_published,
    hotel_name,
    hotel_stars,
    hero_image,
    inclusions
  }
`;

export const FEATURED_PACKAGES = `
  *[_type == "tourPackage" && is_featured == true && is_published == true] {
    _id,
    _updatedAt,
    title,
    slug,
    destination,
    duration_days,
    duration_nights,
    price_per_person_aed,
    hero_image,
    inclusions
  }
`;

// -- UAE Tours & Activities ---------------------------------------------------

const UAE_TOUR_FIELDS = `
  _id,
  title,
  slug,
  category,
  featuredImage,
  gallery,
  shortDescription,
  fullDescription,
  startingPrice,
  priceLabel,
  duration,
  pickupIncluded,
  pickupLocation,
  dropoffIncluded,
  tourType,
  bestFor,
  highlights,
  inclusions,
  exclusions,
  itinerary,
  thingsToKnow,
  cancellationPolicy,
  faqs,
  metaTitle,
  metaDescription,
  featured,
  popular,
  displayOrder,
  whatsappMessage
`;

export const ALL_UAE_TOURS = `
  *[_type == "uaeTour" && (!defined(isPublished) || isPublished == true)] | order(displayOrder asc, featured desc, popular desc, title asc) {
    ${UAE_TOUR_FIELDS}
  }
`;

export const UAE_TOUR_BY_SLUG = `
  *[_type == "uaeTour" && slug.current == $slug && (!defined(isPublished) || isPublished == true)][0] {
    ${UAE_TOUR_FIELDS}
  }
`;

// -- Blog Posts ----------------------------------------------------------------

export const ALL_BLOG_POSTS = `
  *[_type == "blogPost" && is_published == true] | order(published_date desc) {
    _id,
    _updatedAt,
    title,
    slug,
    excerpt,
    published_date,
    is_published,
    hero_image,
    author,
    category,
    seo_title,
    seo_description
  }
`;

export const POST_BY_SLUG = `
  *[_type == "blogPost" && slug.current == $slug][0] {
    _id,
    _updatedAt,
    title,
    slug,
    excerpt,
    published_date,
    is_published,
    hero_image,
    author,
    category,
    body,
    seo_title,
    seo_description
  }
`;

// -- Site Settings -------------------------------------------------------------

export const SITE_SETTINGS = `
  *[_type == "siteSettings"][0] {
    _id,
    phone,
    whatsapp_number,
    email,
    address,
    office_hours,
    facebook_url,
    instagram_url,
    twitter_url,
    homepage_hero_image,
    homepage_hero_headline,
    homepage_hero_subtitle
  }
`;
